// export const API_BASE_URL = "http://localhost:4000/api";
// prod
export const API_BASE_URL = "https://next-api-mksp.vercel.app/api";

export const NUMBER_ADMIN = "+243243243243" 